/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { ApproveWorkflowStepPaymentRequestsRequestSupplier } from './approve-workflow-step-payment-requests-request-supplier';

/**
 * 
 * @export
 * @interface ApproveWorkflowStepPaymentRequestsRequest
 */
export interface ApproveWorkflowStepPaymentRequestsRequest {
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'workflowStepInstanceId': string;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'comment': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'id': string;
    /**
     * 
     * @type {ApproveWorkflowStepPaymentRequestsRequestSupplier}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'supplier': ApproveWorkflowStepPaymentRequestsRequestSupplier;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'transferFeeResponsibility': ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'memo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'withholdingCalculatingMethod': ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof ApproveWorkflowStepPaymentRequestsRequest
     */
    'withholdingAmount': number | null;
}

export const ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum = {
    self: 'SELF',
    supplier: 'SUPPLIER'
} as const;

export type ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum = typeof ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum[keyof typeof ApproveWorkflowStepPaymentRequestsRequestTransferFeeResponsibilityEnum];
export const ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum = {
    none: 'NONE',
    manuscriptOrLecture: 'MANUSCRIPT_OR_LECTURE',
    lawyerOrCpa: 'LAWYER_OR_CPA',
    judicialScrivener: 'JUDICIAL_SCRIVENER',
    other: 'OTHER'
} as const;

export type ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum = typeof ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum[keyof typeof ApproveWorkflowStepPaymentRequestsRequestWithholdingCalculatingMethodEnum];


